module.exports = __webpack_public_path__ + "static/img/62.d773e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/62.jpg
// module id = pgNh
// module chunks = 0